import axios from "axios";

import * as types from "./actionTypes";

export const getLibrary = () => (dispatch, getStore) => {
  const { libraryId } = getStore().map;

  axios
    .get(process.env.REACT_APP_API_URL + "/library/" + libraryId)
    .then(({ data }) => {
      dispatch({
        type: types.LIBRARY_GET,
        data
      });
      return data.response;
    });
};

export const closeLibrary = () => ({
  type: types.LIBRARY_CLOSE
});

export const asyncSelectLibrary = id => ({
  type: "LIBRARY",
  payload: axios.get(`${process.env.REACT_APP_API_URL}/library/${id}`)
});



// WEBPACK FOOTER //
// ./src/modules/library/actions.js